import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import {FadeZoomInTop} from "../../animations/fade-zoom-in-top.decorator";
import { Title } from '@angular/platform-browser';
import { ClientService } from "../../services/client.service";
import { AuthService } from "../../services/auth.service";
import { Router, ActivatedRoute } from '@angular/router';
import * as moment from 'moment';
import { AuditTrailService } from "../../services/audit-trail.service";
import { AuditTrailModel } from "../../models/audit-trail.model";
import { setTimeout } from 'timers';

@FadeZoomInTop()
@Component({
  selector: 'app-main-layout',
  templateUrl: './main-layout.component.html',
  styles: []
})
export class MainLayoutComponent implements OnInit {
  client: any = {};
  user: any = {};
  roles: string = "";
  lastIn: any = '';
  currentPage = '';
  timeSpentOnPages = [];
  moment = moment;
  ipAddress: string="";
  auditTrailModel: AuditTrailModel = new AuditTrailModel();

  constructor(private clientService: ClientService, public _location: Location, private titleService: Title, private router: Router, private auditService: AuditTrailService, private authService: AuthService) {
    this.client = this.clientService.getClient();
    if (this.client == null) return;
    this.user = this.authService.getUser();
    this.titleService.setTitle(this.client.clientSetting.name);
    if (this.client.clientSetting.siteSetting.enableAuditTrail == true) {
    this.router.events.subscribe((event: any) => {
      if (!this.currentPage) {
        this.currentPage = event.url;
        this.lastIn = Date.now();
      }
      if (this.currentPage !== event.url && event.url != undefined && this.auditTrailModel.pageURL =="") {
        const timeSpent = Date.now() - this.lastIn;
        console.log('timeSpent', timeSpent);
        const pageInfo = {
          pageUrl: this.currentPage,
          timeSpent
        }
        this.timeSpentOnPages.push(pageInfo);
        this.lastIn = Date.now();
        this.currentPage = event.url;

        if (this.user != null) {
          this.auditTrailModel.clientId = this.user.user.ClientId;
          this.auditTrailModel.userId = this.user.id
        }
        this.auditTrailModel.pageURL = pageInfo.pageUrl;
        this.auditTrailModel.duration = moment.utc(pageInfo.timeSpent).format('H:mm:ss');
        this.auditTrailModel.ipAddress = "";
        this.auditTrailModel.createdBy = this.user.id;
        this.auditTrailModel.updatedBy = this.user.id;
        this.auditTrailModel.userName = this.user.user.UserName;
        this.auditTrailModel.clientCode = this.client.clientCode;

        //this.auditService.getIPAddress().subscribe((res: any) => {
          
        //  debugger;
        //  console.log(JSON.stringify(res));
        //  //this.auditTrailModel.ipAddress = res.ip;
        //});
        if (moment.utc(pageInfo.timeSpent).format('H:mm:ss') != "0:00:00" &&  this.auditTrailModel.pageURL != "/") {
          this.auditService.auditTrailDetails(this.auditTrailModel).then();
        }
      }
    });
    }
 }

  ngOnInit() {
   
  }

  ngAfterViewInit() {
    if (document.getElementById('panelGrid') != null) {
        var pageHeight = ((document.getElementById('panelGrid').clientHeight * 2) + 60) + "px";
        if (document.getElementById('parentPageContent') != null) {
          document.getElementById('parentPageContent').setAttribute("style", "min-height:" + pageHeight);
        }
      }
  } 

}
